// src/com/dc_info/DcInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * DC_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-08-26 14:04:45 using DbdbTap
 ************************************************ */

export const DC_INFO_LIST_PART = gql`
fragment DcInfoListPart on DcInfo {
    dcCd
    dcTypeCd
    dcTypeName
    dcName
    useYn
    zipCd
    addr
    docknoStart
    docknoEnd
    officeTelno
    officeStaffName
    secuTelno
    secuStaffName
    transStaffName
    operStaffName
    pierTimeIntervalCd
    pierTimeInterval
    showOrder
    tempFore
    tempMid
    tempRear
    useTransType
    fontColor
    backColor
    regDate
    regUser
    regUserName
}
`;
/*
    lat
    lon
    xCoord
    yCoord
    zoneShape
    useZone
*/


export const LIST_DC_INFO = gql`
${DC_INFO_LIST_PART}
query ListDcInfo {
    dcInfoList {
        ...DcInfoListPart
    }
}
`;

export const GET_DC_INFO = gql`
${DC_INFO_LIST_PART}
query GetDcInfo($dcCd:String!) {
    dcInfoItem(dcCd:$dcCd) {
        ...DcInfoListPart
    }
}
`;

/* 
// dcInfoSetZone(dcInfo: InputDcInfoSetZone!): CommonResponse
export const SET_ZONE_DC_INFO = gql`
mutation SetZoneDcInfo($dcInfo:InputDcInfoSetZone!) {
    dcInfoSetZone(dcInfo: $dcInfo) {
        ok
        message
    }
}
`;

// dcInfoSetUsage(dcInfo: InputDcInfoSetUseYn!): ResponseWithDcInfoList
export const SET_USAGE_DC_INFO = gql`
${DC_INFO_LIST_PART}
mutation SetUsageDcInfo($dcInfo:InputDcInfoSetUseYn!) {
    dcInfoSetUsage(dcInfo: $dcInfo) {
        ok
        message
        list {
            ...DcInfoListPart
        }
    }
}
`;

export const LIST_DC_INFO_WITH_RENT_VEH_COUNT = gql`
query ListDcInfoWithRentVehCount {
    dcInfoListWithRentVehCount {
        dcCd
        dcTypeCd
        dcTypeName
        dcName
        countVehicle
    }
}
`; */